export const tracing_sample_rate = (input: string): string => {
  if (!input) {
    return "";
  }

  if (
    !(parseFloat(input) >= 0 && parseFloat(input) <= 100) ||
    !isItNumber(input)
  ) {
    return "Sample Rate must be between 0 and 100";
  }
  return "";
};

function isItNumber(str: string) {
  return /^-?[0-9]+(e[0-9]+)?(\.[0-9]+)?$/.test(str);
}
